import axios from './base'
const url = `/index`

/* MOCK 登录：无需后端即可进入系统。接真实后端时改为 false。 */
const USE_MOCK = false

export function index(params = {}) {
  return axios.request({
    url: `${url}/index`,
    method: "get",
    params,
  })
}

export function getInited(params = {}) {
  return axios.request({
    url: `${url}/inited`,
    method: "get",
    params,
  })
}

export function login(data = {}) {
  if (USE_MOCK) {
    const menu = {
      '1': { name: '工作台', url: 'home', icon: 'el-icon-s-home' },
      '2': { name: '实时监控', url: 'monitor', icon: 'el-icon-location' },
      '3': { name: '厂区管理', url: 'factory', icon: 'el-icon-office-building' },
      '4': { name: '设备管理', url: 'device', icon: 'el-icon-truck' },
      '5': { name: '安全管理', url: 'security', icon: 'el-icon-warning' },
      '6': { name: '告警中心', url: 'alert', icon: 'el-icon-bell' },
      '7': { name: '数据中心', url: 'data-center', icon: 'el-icon-data-analysis' },
      '8': { name: '账号管理', url: 'mine', icon: 'el-icon-user' }
    }
    const permission = {
      home: 1, monitor: 1,
      factory_view: 1, factory_add: 1, factory_edit: 1, factory_delete: 1,
      device_view: 1, device_bind: 1, device_unbind: 1, device_rebind: 1, device_edit: 1,
      security_view: 1, security_add: 1, security_edit: 1, security_delete: 1,
      alert_view: 1, alert_handle: 1,
      data_center_view: 1,
      mine_view: 1, mine_sub_add: 1, mine_sub_edit: 1, mine_sub_delete: 1, enterprise_view: 1, enterprise_edit: 1,
      system_admin: 1, menu: 1, permission: 1, role: 1, tag: 1, group: 1
    }
    return new Promise(resolve => setTimeout(() => resolve({
      code: 200,
      data: {
        token: 'mock-token-' + Date.now(),
        user: { nickname: '主账号管理员', avatar: '', mobile: '13800000000', role: 'admin' },
        menu: menu,
        permission: permission
      }
    }), 150))
  }
  return axios.request({
    url: `/auth/web-login`,
    method: "post",
    data: data,
  })
}

export function register(data = {}) {
  console.log(data)
  return axios.request({
    url: `${url}/register`,
    method:`post`,
    data:data
  })
}
export function getProvince(data = {}){
  return axios.request({
    url: `${url}/../provinces`,
    method: 'get',
    params: data
  })
}

export function getCity(id,data = {}){
  return axios.request({
    url: `${url}/../cities/${id}`,
    method: 'get',
    params: data
  })
}

export function getArea(id,data = {}){
  return axios.request({
    url: `${url}/../areas/${id}`,
    method: 'get',
    params: data
  })
}

export function getQiniuToken(data){
  return axios.request({
    url: `${url}/../cdn/token`,
    method: 'post',
    data: data
  })
}

export function tencentAddressKeyword(params={}){
  return axios.request({
    url: `${url}/../address/keyword`,
    method: 'get',
    params: params
  }) 
}

export function areaDetailCode(params={}){
  return axios.request({
    url: `${url}/../area/detail`,
    method: 'get',
    params: params
  }) 
}

export function getReport(params = {}) {
  return axios.request({
    url: `${url}/../report/year`,
    method: "get",
    params,
  })
}
export function getReportMonth(params = {}) {
  return axios.request({
    url: `${url}/../report/monthly`,
    method: "get",
    params,
  })
}

export function getReportGroup(params = {}) {
  return axios.request({
    url: `${url}/../report/group`,
    method: "get",
    params,
  })
}
export function getReportStore(params = {}) {
  return axios.request({
    url: `${url}/../report/store`,
    method: "get",
    params,
  })
}


export function calendar(params = {}) {
  return axios.request({
    url: `${url}/../calendar`,
    method: "get",
    params,
  })
}
export function getTemples(params = {}) {
  return axios.request({
    url: `${url}/../temples/select`,
    method: "get",
    params,
  })
}
export function getBless(params = {}) {
  return axios.request({
    url: `${url}/../niche/bless/select`,
    method: "get",
    params,
  })
}

export function getOrderStatistics(params = {}){
  return axios.request({
    url: `${url}/../statistics/order/today`,
    method: "get",
    params,
  })
}
